<template>
  <div class="filter-saver">
    <el-dialog
      :visible.sync="dialogOpen"
      :show-close="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div class="filter-saver__title">Save to Watchlist</div>
      <div class="filter-saver__name">
        <div div class="filter-saver__subtitle" :class="{ error: nameError }">
          Filter group name
        </div>
        <input
          v-model="filterName"
          type="text"
          placeholder="Enter a name for this filter group"
          class="filter-saver__name-field"
          :class="{ error: nameError }"
        />
        <div v-if="nameError" class="input-error">
          You need to give this filter group a name (eg. Anti-Money Laundering
          in Europe)
        </div>
      </div>
      <div class="filter-saver__selected">
        <div div class="filter-saver__subtitle">Selected filters</div>
        <div v-if="searchQuery" class="filter-saver__selected-wrapper">
          <div
            v-for="(group, index) in searchQuery"
            :key="index"
            class="filter-saver__selected-group"
          >
            <!-- <div class="group-tags">
                  <Tag
                    :v-if="tag.label.length > 0"
                    v-for="(tag, index) in group"
                    :key="index"
                    :text="tag.label"
                    :background="'dark-red'"
                  />
              </div> -->
          </div>
        </div>
      </div>
      <div class="filter-saver__selected">
        <div div class="filter-saver__subtitle">
          Alert service email preferences
        </div>
        <el-select v-model="value" placeholder="Select">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="filter-saver__buttons">
        <button class="save-btn" @click="save">Save</button>
        <button class="cancel-btn" @click="cancel">Cancel</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "FilterSaver",
  components: {
    // Tag: () => import("../elements/Tag"),
  },
  data() {
    return {
      filterName: "",
      value: "daily",
      nameError: false,
      options: [
        {
          value: "daily",
          label: "Immediate alerts",
        },
        {
          value: "weekly",
          label: "Weekly alerts",
        },
        {
          value: "monthly",
          label: "Monthly alerts",
        },
        {
          value: "none",
          label: "No alerts",
        },
      ],
    };
  },
  computed: {
    dialogOpen: {
      get() {
        return this.$store.state.Dialog.filterSaverDialog;
      },
      set(value) {
        this.$store.commit("Dialog/setData", {
          label: "filterSaverDialog",
          data: value,
        });
      },
    },
    filterData() {
      return this.$store.state.Dialog.filterSaverDialogData;
    },
    searchQuery() {
      return this.$store.state.Search.searchQuery;
    },
  },
  watch: {
    filterName: {
      handler(val) {
        if (val) {
          this.nameError = false;
        }
      },
    },
  },
  methods: {
    cancel() {
      this.$store.commit("Dialog/setData", {
        label: "filterSaverDialog",
        data: false,
      });
      this.$store.commit("Dialog/setData", {
        label: "filterSaverDialogData",
        data: null,
      });
      this.filterName = "";
    },
    save() {
      if (this.filterName && this.filterName.length) {
        const data = {};
        let store = null;
        /* for (let key in this.filterData.draw) {
          data[key.slice(0, key.length - 2)] = this.filterData[key]
        } */
        data.tags = this.filterData.save
          .split(",")
          .reduce(
            (acc, elem) =>
              Number.isInteger(Number(elem)) ? [...acc, Number(elem)] : acc,
            []
          );

        data.type = "all";

        if (this.$nuxt.$route.name === "world") {
          data.type = "guides";
          store = "Guides";
        }
        if (this.$nuxt.$route.name === "requirement") {
          data.type = "requirements";
          store = "Requirement";
        }
        if (this.$nuxt.$route.name === "insights") {
          data.type = "insights";
          store = "Insights";
        }
        if (this.$nuxt.$route.name === "regulatory_analysis") {
          data.type = "regulatory_analysis";
          store = "Analysis";
        }
        if (this.$nuxt.$route.name === "reports") {
          data.type = "guides";
          store = "Guide";
        }
        if (this.$nuxt.$route.name === "search") {
          data.type = "all";
          store = "Search";
        }
        if (
          this.$nuxt.$route.name === "regulatory_updates_list" ||
          this.$nuxt.$route.name === "regulatory_updates"
        ) {
          data.type = "horizon_scanning";
          store = "Updates";
        }

        data.emailPreferences = this.value;
        data.name = this.filterName;
        data.tags = data.tags.filter((elem) => elem !== undefined);
        this.$store
          .dispatch("Global/saveFilterToWatchlist", data)
          .then(({ data }) => {
            this.$store.commit("Dialog/setData", {
              label: "filterSaverDialog",
              data: false,
            });

            this.$store.commit("Dialog/setData", {
              label: "filterSaverDialogData",
              data: null,
            });

            this.$store.commit(`${store}/appendData`, {
              label: "watchlist",
              data,
            });
          })
          .catch((error) => console.error(error));
        this.filterName = "";
      } else {
        this.nameError = true;
      }
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/styles/helpers/mixin";
@import "../../assets/styles/helpers/variables";
.filter-saver {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog {
    margin-top: 30rem !important;
    width: 49rem;

    @include below($md) {
      width: 90%;
      margin-top: 10rem !important;
    }
  }

  .el-select {
    width: 100%;

    .el-input .el-input__inner {
      border: 1px solid #c6d5e0;
      padding: 0 2rem;
    }
  }

  &__title {
    font-size: 2.4rem;
    font-weight: 700;
    color: #262a2e;
    border-bottom: 1px dashed $border;
    margin-bottom: 3rem;
  }

  &__subtitle {
    font-size: 1.6rem;
    font-weight: 700;
    color: #262a2e;
    margin-bottom: 0.6rem;

    &.error {
      color: $dark_red;
    }
  }

  &__name {
    margin-bottom: 2rem;

    &-field {
      border: 1px solid #c6d5e0;
      width: 100%;
      height: 4.5rem;
      padding: 0 2rem;
      font-size: 1.6rem;

      &.error {
        border-color: $dark_red;

        &::placeholder {
          color: $dark_red;
        }
      }
    }

    .input-error {
      color: $red;
      font-size: 1.4rem;
      font-weight: 600;
      margin-top: 1rem;
    }
  }

  &__selected {
    margin-bottom: 2rem;

    &-group {
      margin-bottom: 1rem;
    }

    .group-title {
      font-size: 1.2rem;
      font-weight: 700;
      text-transform: uppercase;
      color: #262a2e;
      border-bottom: 1px dashed $border;
      padding-bottom: 0.2rem;
      margin-bottom: 1rem;
    }
  }

  .save-btn {
    background: $red;
    border: none;
    font-size: 1.6rem;
    color: #fff;
    font-weight: 600;
    padding: 1rem 4rem;
    margin-right: 3rem;
  }

  .cancel-btn {
    background: none;
    border: none;
    font-size: 1.6rem;
    color: #383838;
  }
}
</style>
